import React from 'react';
import styles from './styles.module.scss';

export const Image = ({ attributes, children, element }) => (
  <figure contentEditable {...attributes}>
    <img src={element.url} alt="" className={styles.img} />
    <figcaption className={styles.figcaption}>{children}</figcaption>
  </figure>
);
